import {BaseDto} from 'common';

export class AccountAdminOverviewDto extends BaseDto {

    email: string;
    firstName: string;
    lastName: string;
    country: string;

    public get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
